import styled from 'styled-components';

const FileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  & img {
    max-width: 180px;
    max-height: 140px;
    border-radius: 8px;
    object-fit: cover;
    display: block;
  }
`;

export default FileContent;
